import { Link } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import "./MembershipCard.css";

export default function MembershipCard({ plan }) {
  return (
    <article className={`membership-card ${plan.popular ? "membership-card--popular" : ""}`}>
      {plan.popular && <span className="membership-card__badge">Most Popular</span>}
      <p className="membership-card__duration">{plan.duration}</p>
      <h3 className="membership-card__name">{plan.name}</h3>
      <p className="membership-card__price">{plan.price}</p>
      <ul className="membership-card__features">
        {plan.features.map((feature) => (
          <li key={feature}>
            <FiCheck aria-hidden="true" /> {feature}
          </li>
        ))}
      </ul>
      <Link
        to="/contact"
        className={plan.popular ? "btn btn-primary" : "btn btn-outline"}
        style={{ width: "100%", justifyContent: "center" }}
      >
        Enquire Now
      </Link>
    </article>
  );
}
